import { MyCardService } from '@addins/core/core';
import { Component, Input, OnInit } from '@angular/core';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { Tool } from '@services/tools';
import { MediaToolsProviderService } from '../../services/media-tools-provider/media-tools-provider.service';

@Component({
  selector: 'app-callcard-media-buttons',
  templateUrl: './callcard-media-buttons.component.html',
  styleUrls: ['./callcard-media-buttons.component.scss']
})
export class CallcardMediaButtonsComponent implements OnInit {
  @Input()
  readonly callcard: CallCard;

  private _mediaTools: Tool[] = null;
  get mediaTools(): Tool[] {
    return this._mediaTools;
  }

  get isMine(): boolean {
    return this.callcard === this.myCardService.myCard;
  }

  constructor(private myCardService: MyCardService, private mediaToolsProvider: MediaToolsProviderService) {}

  ngOnInit() {
    this._mediaTools = this.mediaToolsProvider.mediaTools;
  }

  execute(tool: Tool) {
    tool.execute({ callcard: this.callcard });
  }
}
